function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable max-statements */
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Table, ConfirmNavigationModal, ConfirmationModal, ProgressBar } from "../../../Components/UI";
import { Translate } from "../../../../I18N/Translate";

import {

  useLoaderData,
  useNavigate,
  useBlocker,
  useRevalidator } from
'react-router';
import * as templatesAPI from "../../../api/templates";
import * as pagesAPI from "../../../api/pages";


import { isEqual } from 'lodash';
import { useSetAtom, useAtomValue } from 'jotai';
import { notificationAtom, templatesAtom } from "../../../atoms";
import uniqueID from "../../../../../shared/uniqueID";
import { socket } from "../../../../socket";
import {
  cleanProperty,
  emptyTemplate,
  processDefaultProperties,
  processProperties,
  confirmationMessages } from "./helpers";

import { propertyColumns } from "./components/TemplateEditorTableComponents";
import { TemplateMetadata } from "./components/TemplateMetadata";
import { AddRelationshipTypeModal } from "./components/AddRelationshipTypeModal";
import { AddThesaurusModal } from "./components/AddThesaurusModal";
import { TemplatesEditorFooter } from "./components/TemplatesEditorFooter";
import { ConfigPropertyPanel } from "./components/ConfigPropertyPanel";

const templatesEditorLoader =
(headers) =>
async ({ params }) => {
  const allPages = await pagesAPI.get(headers);
  const pages = allPages.filter((page) => page.entityView);
  const pagesOptions = pages.map((page) => ({
    value: page.sharedId,
    label: page.title
  }));
  let loadedTemplate = emptyTemplate;
  const templates = await templatesAPI.get(headers);

  if (params.templateId) {
    const templateToEdit = templates.find((template) => template._id === params.templateId);
    if (templateToEdit) {
      loadedTemplate = templateToEdit;
    }
  }

  return { loadedTemplate, pagesOptions };
};

const TemplatesEditor = () => {var _template$processing3;
  const navigate = useNavigate();
  const revalidator = useRevalidator();
  const { loadedTemplate, pagesOptions } = useLoaderData();



  const [template, setTemplate] = useState(loadedTemplate);
  const [properties, setProperties] = useState([]);
  const [commonProperties, setCommonProperties] = useState([]);
  const [selected, setSelected] = useState([]);
  const setNotifications = useSetAtom(notificationAtom);
  const templates = useAtomValue(templatesAtom);
  const [nameError, setNameError] = useState(false);
  const [colorError, setColorError] = useState(false);
  const [showNavigationModal, setShowNavigationModal] = useState(false);
  const [showRelationshipTypeModal, setShowRelationshipTypeModal] = useState(false);
  const [showThesaurusModal, setShowThesaurusModal] = useState(false);
  const [showConfigPropertyPanel, setShowConfigPropertyPanel] = useState(false);
  const [propertyToEdit, setPropertyToEdit] = useState();
  const [showReindexModal, setShowReindexModal] = useState(false);
  const [showLargeEntityCountModal, setShowLargeEntityCountModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const ENTITY_COUNT_THRESHOLD = 3000;

  const handleTemplateProcessed = async (data) => {
    if (data.templateId !== template._id) {
      return;
    }

    await revalidator.revalidate();
    setNotifications({
      type: 'success',
      text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Template processing completed.")
    });
  };

  const handleTemplateProcessing = async (data) =>






  {
    if (data.templateId !== template._id) {
      return;
    }

    setTemplate(_objectSpread(_objectSpread({}, template), {}, { processing: data.processing }));
  };

  useEffect(() => {
    socket.on('templateProcessed', handleTemplateProcessed);
    socket.on('templateProcessing', handleTemplateProcessing);
    return () => {
      socket.off('templateProcessed', handleTemplateProcessed);
      socket.off('templateProcessing', handleTemplateProcessing);
    };
  });

  useEffect(() => {
    setProperties(processProperties(loadedTemplate.properties || []));
  }, [loadedTemplate.properties]);

  useEffect(() => {
    setCommonProperties(processDefaultProperties(loadedTemplate.commonProperties || []));
  }, [loadedTemplate.commonProperties]);

  useEffect(() => {var _loadedTemplate$proce;
    setTemplate(loadedTemplate);
    if ((_loadedTemplate$proce = loadedTemplate.processing) !== null && _loadedTemplate$proce !== void 0 && _loadedTemplate$proce.active) {
      setNotifications({
        type: 'warning',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Template is being processed. Please wait for it to finish.")
      });
    }
  }, [loadedTemplate]);

  const getCurrentStatus = useCallback(() => {
    const cleanedCommonProperties = commonProperties.map(cleanProperty);
    const cleanedProperties = properties.map(cleanProperty);

    return _objectSpread(_objectSpread({},
    template), {}, {
      commonProperties: cleanedCommonProperties,
      properties: cleanedProperties });

  }, [template, commonProperties, properties]);

  const checkPendingChanges = useCallback(
    //ignore processing
    () =>
    !isEqual(_objectSpread(_objectSpread({},
    loadedTemplate), {}, { processing: undefined }), _objectSpread(_objectSpread({},
    getCurrentStatus()), {}, { processing: undefined })
    ),
    [getCurrentStatus, loadedTemplate]
  );

  const blocker = useBlocker(
    ({ nextLocation }) =>
    !(nextLocation !== null && nextLocation !== void 0 && nextLocation.pathname.includes('templates/edit')) && checkPendingChanges()
  );

  useMemo(() => {
    if (blocker.state === 'blocked') {
      setShowNavigationModal(true);
    }
  }, [blocker, setShowNavigationModal]);

  const allProperties = useMemo(
    () => [...commonProperties, ...properties],
    [commonProperties, properties]
  );

  const handleTableChange = ({
    selectedRows,
    rows



  }) => {
    setSelected(rows.filter((row) => selectedRows[row.rowId]).map((row) => row.rowId));
    const newCommonProperties = rows.filter((row) => row.isCommonProperty);
    const newProperties = rows.filter((row) => !row.isCommonProperty);
    if (!isEqual(newCommonProperties, commonProperties)) {
      setCommonProperties(newCommonProperties);
    }
    if (!isEqual(newProperties, properties)) {
      setProperties(newProperties);
    }
  };

  const save = async (forceReindex = false) => {var _savedTemplate$proces;
    const templateToSave = getCurrentStatus();

    if (forceReindex) {
      templateToSave.reindex = true;
    }

    const savedTemplate = await templatesAPI.save(templateToSave);
    await revalidator.revalidate();

    if ((_savedTemplate$proces = savedTemplate.processing) !== null && _savedTemplate$proces !== void 0 && _savedTemplate$proces.active) {
      setNotifications({
        type: 'warning',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Template is being processed. Please wait for it to finish.")
      });
    } else {
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Template saved successfully.")
      });
    }

    await navigate(`/settings/templates/edit/${savedTemplate._id}`, { replace: true });
  };

  const handlePropertySave = (propertyConfig) => {
    if (propertyToEdit && propertyConfig.isCommonProperty) {
      setCommonProperties((current) =>
      current.map((p) => p.rowId === propertyToEdit.rowId ? _objectSpread(_objectSpread({}, p), propertyConfig) : p)
      );
      return;
    }

    if (propertyToEdit) {
      setProperties((current) =>
      current.map((p) => p.rowId === propertyToEdit.rowId ? _objectSpread(_objectSpread({}, p), propertyConfig) : p)
      );
      return;
    }

    setProperties((current) => [...current, _objectSpread(_objectSpread({}, propertyConfig), {}, { rowId: uniqueID() })]);
  };

  const handleSave = async (ignoreEntityCount = false) => {
    const isDuplicateName = templates.some(
      (t) => t.name.toLowerCase() === template.name.toLowerCase() && t._id !== template._id
    );
    setNameError(!template.name || isDuplicateName);
    if (!template.name || isDuplicateName) {
      return;
    }

    if (template._id) {
      const entityCounts = await templatesAPI.checkTemplatesEntityCount(undefined, [template._id]);
      const entityCount = entityCounts[template._id] || 0;

      if (entityCount > ENTITY_COUNT_THRESHOLD && !ignoreEntityCount) {
        setShowLargeEntityCountModal(true);
        return;
      }
    }

    try {
      setIsSaving(true);
      await save();
    } catch (e) {
      if (e.status === 409) {
        setShowReindexModal(true);
        return;
      }
      setNotifications({ type: 'error', text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error saving template.") });
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = () => {
    setProperties((current) => current.filter((row) => !selected.includes(row.rowId)));
  };

  const handleEditProperty = (property) => {
    setPropertyToEdit(property);
    setShowConfigPropertyPanel(true);
  };

  const progress = useMemo(
    () => {var _template$processing, _template$processing2;return (((_template$processing = template.processing) === null || _template$processing === void 0 ? void 0 : _template$processing.completedJobs) || 0) / (((_template$processing2 = template.processing) === null || _template$processing2 === void 0 ? void 0 : _template$processing2.totalJobs) || 1) * 100;},
    [template.processing]
  );

  const progressBar = /*#__PURE__*/
  _jsx("div", { className: "w-full flex flex-col gap-2" }, void 0, /*#__PURE__*/
  _jsx("div", { className: "flex justify-between mb-1" }, void 0, /*#__PURE__*/
  _jsx(Translate, { className: "text-base font-medium text-gray-500 text-xs" }, void 0, "Processing template..."

  ), /*#__PURE__*/
  _jsx("span", { className: "text-sm font-medium text-gray-500" }, void 0, progress.toFixed(2), "%")
  ), /*#__PURE__*/
  _jsx(ProgressBar, { progress: progress, color: "gray" })
  );


  return (/*#__PURE__*/
    _jsx("div", { className: "w-full h-full overflow-y-auto" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      title: template.name,
      path: new Map([['Templates', '/settings/templates']]),
      className: "flex items-center gap-2" }, void 0,

    ((_template$processing3 = template.processing) === null || _template$processing3 === void 0 ? void 0 : _template$processing3.active) && progressBar
    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: propertyColumns(handleEditProperty),
      data: allProperties,
      enableSelections: true,
      dnd: { enable: true },
      onChange: handleTableChange,
      header: /*#__PURE__*/
      _jsx(TemplateMetadata, {
        value: {
          name: template.name,
          color: template.color || '#C03B22',
          entityViewPage: template.entityViewPage || ''
        },
        onChange: (values) => {
          setTemplate(_objectSpread(_objectSpread({}, template), values));
          if (values.name) setNameError(false);
          if (values.color) setColorError(false);
        },
        pages: pagesOptions,
        nameError: nameError,
        colorError: colorError }
      ) }

    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx(TemplatesEditorFooter, {
      selected: selected,
      onDelete: handleDelete,
      onSave: handleSave,
      onAddThesaurus: () => setShowThesaurusModal(true),
      onAddRelationshipType: () => setShowRelationshipTypeModal(true),
      onAddProperty: () => setShowConfigPropertyPanel(true),
      disableSave: !checkPendingChanges() || isSaving }
    )
    )
    ),
    showNavigationModal && /*#__PURE__*/
    _jsx(ConfirmNavigationModal, { setShowModal: setShowNavigationModal, onConfirm: blocker.proceed }),

    showRelationshipTypeModal && /*#__PURE__*/
    _jsx(AddRelationshipTypeModal, { onClose: () => setShowRelationshipTypeModal(false) }),

    showThesaurusModal && /*#__PURE__*/_jsx(AddThesaurusModal, { onClose: () => setShowThesaurusModal(false) }), /*#__PURE__*/

    _jsx(ConfigPropertyPanel, {
      isOpen: showConfigPropertyPanel,
      onSubmit: handlePropertySave,
      onClose: () => {
        setShowConfigPropertyPanel(false);
        setPropertyToEdit(undefined);
      },
      template: _objectSpread(_objectSpread({}, template), {}, { properties, commonProperties }),
      propertyToEdit: propertyToEdit }
    ),
    showLargeEntityCountModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      size: "lg",
      header: confirmationMessages.largeNumberOfEntities.title,
      body: /*#__PURE__*/
      _jsx(Translate, { translationKey: confirmationMessages.largeNumberOfEntities.key }, void 0,
      confirmationMessages.largeNumberOfEntities.text
      ),

      onAcceptClick: async () => {
        setShowLargeEntityCountModal(false);
        await handleSave(true);
      },
      onCancelClick: () => setShowLargeEntityCountModal(false),
      acceptButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "Continue"),
      cancelButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "Cancel"),
      dangerStyle: true }
    ),

    showReindexModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      size: "lg",
      header: confirmationMessages.templateConflict.title,
      body: /*#__PURE__*/
      _jsx(Translate, { translationKey: confirmationMessages.templateConflict.key }, void 0,
      confirmationMessages.templateConflict.text
      ),

      onAcceptClick: async () => {
        setShowReindexModal(false);
        try {
          setIsSaving(true);
          await save(true);
        } catch (e) {
          if (e.status === 409) {
            setShowReindexModal(true);
            return;
          }
          setNotifications({
            type: 'error',
            text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error saving template.")
          });
        } finally {
          setIsSaving(false);
        }
      },
      onCancelClick: () => setShowReindexModal(false),
      acceptButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "Continue"),
      cancelButton: /*#__PURE__*/_jsx(Translate, {}, void 0, "Cancel"),
      dangerStyle: true }
    )

    ));

};

export { TemplatesEditor, templatesEditorLoader };